// 整劇預約上架：一律以台北時間的整點表示，後端 publishScheduledDramas 每小時整點執行。
const TAIPEI_OFFSET_MS = 8 * 60 * 60 * 1000;
const HOUR_MS = 60 * 60 * 1000;

/** "YYYY-MM-DD" + 小時（台北）→ UTC Date；格式不符回傳 null。 */
export function taipeiHourToDate(date: string, hour: number): Date | null {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(date);
  if (!m || !Number.isInteger(hour) || hour < 0 || hour > 23) return null;
  return new Date(Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3]), hour) - TAIPEI_OFFSET_MS);
}

/** UTC Date → 台北的日期與小時，供表單預填。 */
export function dateToTaipeiHour(at: Date): { date: string; hour: number } {
  const t = new Date(at.getTime() + TAIPEI_OFFSET_MS);
  const pad = (n: number) => String(n).padStart(2, "0");
  return { date: `${t.getUTCFullYear()}-${pad(t.getUTCMonth() + 1)}-${pad(t.getUTCDate())}`, hour: t.getUTCHours() };
}

/** 下一個整點（台北），作為預設與最早可選時間。 */
export function nextTaipeiHour(now: number = Date.now()): Date {
  return new Date(Math.floor(now / HOUR_MS) * HOUR_MS + HOUR_MS);
}

/** 顯示用：「10/30 20:00」，跨年時加上年份。 */
export function formatTaipeiHour(at: Date, now: number = Date.now()): string {
  const { date, hour } = dateToTaipeiHour(at);
  const [y, mo, d] = date.split("-");
  const label = `${Number(mo)}/${Number(d)} ${String(hour).padStart(2, "0")}:00`;
  return y === dateToTaipeiHour(new Date(now)).date.slice(0, 4) ? label : `${y}/${label}`;
}

/** 只接受未來的整點。 */
export function validatePublishAt(at: Date | null, now: number = Date.now()): string | null {
  if (!at) return "請選擇日期與時間";
  if (at.getTime() % HOUR_MS !== 0) return "只能選整點";
  if (at.getTime() <= now) return "預約時間必須在現在之後";
  return null;
}
